import { Routes } from '@angular/router';
import { mechanicDictationRoutes } from './dictation/routes';
import { MechanicsPage } from './mechanics-page';
import { mechanicPhoneticComprehensionRoutes } from './phonetic-comprehension/routes';
import { mechanicReadingBasisRoutes } from './reading-basis/routes';
import { mechanicReadingMatrixRoutes } from './reading-matrix/routes';
import { mechanicSortingRoutes } from './sorting/routes';

export const mechanicRoutes: Routes = [
  {
    path: '',
    component: MechanicsPage,
  },
  {
    path: 'sorting',
    children: mechanicSortingRoutes,
  },
  {
    path: 'reading-basis',
    children: mechanicReadingBasisRoutes,
  },
  {
    path: 'reading-matrix',
    children: mechanicReadingMatrixRoutes,
  },
  {
    path: 'dictation',
    children: mechanicDictationRoutes,
  },
  {
    path: 'phonetic-comprehension',
    children: mechanicPhoneticComprehensionRoutes,
  },
];
